async function getAllAchievements() {
  const resData = await window.axios.get('/api/v1/admin/achievement');
  return resData.data;
}

async function EditAchievement(params) {
  const resData = await window.axios.put('/api/v1/admin/achievement', params);
  return resData.data;
}

module.exports = { getAllAchievements, EditAchievement };
